import base64Conversion from './base64conversion';

export function deviceStorage(
  studentId,
  studentNo,
  schoolCode,
  os,
  device,
) {
  return fetch(`${process.env.REACT_APP_API_HEAD}/save-device-info-of-student`,
    {
      method: 'POST',
      body: JSON.stringify({
        student_id: studentId,
        student_no: studentNo,
        school_code: schoolCode,
        device_os: os,
        device_type: device,
      }),

      headers: {
        'content-type': 'application/json',
      },
    });
}
export function getStudentDetails(token, schoolCode) {
  const header = base64Conversion();
  return fetch(`${process.env.REACT_APP_API_HEAD}/responseDirectFromUrl`, {
    method: 'POST',
    body: JSON.stringify({
      student_token: token,
      school_domain: schoolCode,
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: header,
    },
  });
}
